import {parseColor, TYPE_MAP} from "../../config";

export const makeOptions = (data = [], type) => {
  const valueLabel = TYPE_MAP?.[type].label
  const valueFn = TYPE_MAP?.[type].formatFn
  return {
    tooltip: {
      trigger: 'item',
      backgroundColor: 'rgba(255,255,255,0.7)',
      formatter(val) {
        return `<div style="min-width: 160px">
                <div>${val.marker}${val.name}</div>
                <div style="display: flex; justify-content: space-between">
                    <span>占比:</span>
                    <span>${val.percent}%</span>
                </div>
                <div style="display: flex; justify-content: space-between">
                    <span>${valueLabel}:</span>
                    <span>${valueFn(val.value)}</span>
                </div>
              </div>`;
      },
      borderWidth: 0
    },
    series: {
      radius: ['0%', '75%'],
      center: ['50%', '50%'],
      type: 'pie',
      data: data?.map((ele, index) => ({
        value: ele?.value,
        name: ele?.key,
        itemStyle: {
          color: parseColor(ele?.key, index)
        }
      })),
      label: {
        show: true,
      },
      itemStyle: {
        emphasis: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    },
  }
}
